/**
 * Что подставлять в форму записи в следующий раз.
 *
 * Хранится на устройстве, а не в снимке: это привычка ввода, а не данные о
 * деньгах, и возить её между устройствами незачем.
 *
 * Вкладка — по последней записанной операции, как бы её ни записали:
 * вручную, по чеку, файлом, выпиской или «Оплатить» у платежа. Раньше её
 * помнила только ручная запись, и после расхода по чеку форма открывалась
 * на «Приходе», записанном неделю назад (16.10.2026). «В цель» и «Долг» —
 * редкие действия, на них форма сама не открывается.
 */
/**
 * Вкладки формы записи. «В цель» — взнос в цель: перевод с привязкой к ней.
 * «Долг» — погашение: перевод на кредитку или платёж по кредиту.
 */
export type OpType = 'expense' | 'income' | 'transfer' | 'goal' | 'debt';

export const recall = (key: string, fallback: string): string => {
  try { return localStorage.getItem(key) || fallback; } catch { return fallback; }
};

export const recallType = (): OpType => {
  const v = recall('skoka.optype', 'expense');
  return v === 'income' || v === 'transfer' ? v : 'expense';
};

/** Записали операцию этого вида — с него форма и откроется. */
export const rememberType = (type: OpType): void => {
  if (type === 'goal' || type === 'debt') return;
  try { localStorage.setItem('skoka.optype', type); } catch { /* приватный режим — просто не запомним */ }
};

/** Ручная запись помнит ещё категорию и счёт. */
export const remember = (type: OpType, catId: string, accId: string): void => {
  if (type === 'goal' || type === 'debt') return;
  rememberType(type);
  try {
    localStorage.setItem('skoka.cat', catId);
    localStorage.setItem('skoka.acc', accId);
  } catch { /* приватный режим — просто не запомним */ }
};
